import { ref } from 'vue';

export function useFetchData(fn, fieldData = 'data') {
    const result = ref([]);
    const loading = ref(false);
    const error = ref(null);
    const displayHttpError = ref(false);
    const totalItems = ref(0);

    const loadData = async (...args) => {
        loading.value = true;
        error.value = null;
        result.value = [];
        displayHttpError.value = false;

        try {
            const response = await fn(...args);

            totalItems.value = response.total ?? 0;

            if (
                response[fieldData] !== null &&
                response[fieldData] !== undefined
            ) {
                result.value = response[fieldData];
            } else {
                result.value = response;
            }
        } catch (err) {
            if (err && err.data.message) {
                error.value = err.data.message;
            } else {
                error.value = 'unexpected error.';
            }
            displayHttpError.value = true;
        } finally {
            loading.value = false;
        }
    };

    const reset = () => {
        result.value = [];
        totalItems.value = 0;
        loading.value = false;
        error.value = null;
        displayHttpError.value = false;
    };

    return {
        result,
        totalItems,
        loading,
        error,
        displayHttpError,
        loadData,
        reset
    };
}
